import { render, staticRenderFns } from "./ActivityReview.vue?vue&type=template&id=086351a9&"
import script from "./ActivityReview.vue?vue&type=script&lang=js&"
export * from "./ActivityReview.vue?vue&type=script&lang=js&"
import style0 from "./ActivityReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports